import { render, staticRenderFns } from "./classic_monitoring_view.vue?vue&type=template&id=7fb0f501&scoped=true&"
import script from "./classic_monitoring_view.vue?vue&type=script&lang=js&"
export * from "./classic_monitoring_view.vue?vue&type=script&lang=js&"
import style0 from "./classic_monitoring_view.vue?vue&type=style&index=0&id=7fb0f501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb0f501",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fb0f501')) {
      api.createRecord('7fb0f501', component.options)
    } else {
      api.reload('7fb0f501', component.options)
    }
    module.hot.accept("./classic_monitoring_view.vue?vue&type=template&id=7fb0f501&scoped=true&", function () {
      api.rerender('7fb0f501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/monitoring/views/classic_monitoring_view.vue"
export default component.exports